import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  drawer: {
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      "& .MuiDrawer-paperAnchorRight": {
        left: 0
      }
    }
  },
  root: {
    width: "556px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      width: "100%"
    }
  },
  header: {
    height: "60px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 6px 20px 20px",
    backgroundColor: "rgba(238, 238, 238, 0.5)",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "16px 2px 16px 16px"
    }
  },
  closeButton: {
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 26
    }
  },

  content: {
    backgroundColor: "rgba(238, 238, 238, 0.5)"
  },

  preferredConditionsSummary: {
    display: "flex",
    flexDirection: "row",
    padding: "1px 20px",
    alignContent: "center",
    justifyContent: "center",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "1px 16px"
    }
  },
  preferredConditionsSummaryCell: {
    display: "flex",
    textAlign: "center",
    color: "#333333",
    padding: "0 14px",
    fontSize: "14px",
    whiteSpace: "nowrap",
    borderRight: `1px solid ${theme.palette.text.hint}`,
    "&:last-child": {
      borderRight: 0
    },
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0 10px",
      fontSize: "12px"
    }
  },

  matchTypesSummary: {
    height: "67px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center"
  },
  matchTypeSummary: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "14px",
    padding: "0 23px",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      fontSize: "12px",
      padding: "0 24px"
    }
  },
  requestsCountCircle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    width: "25px",
    height: "25px",
    borderRadius: "50%",
    marginRight: 8,
    whiteSpace: "nowrap"
  },
  customRequestsCount: {
    backgroundColor: "#f0e3bf",
    border: "1px solid #998765"
  },
  lastRaceMatchesCount: {
    backgroundColor: "#81daf9",
    border: "1px solid #48769b"
  },

  tableContainer: {
    background: theme.palette.common.white
  },
  tableHead: {
    display: "grid",
    gridTemplateColumns: "40% 30% 15% 15%",
    height: "30px",
    alignContent: "center",
    borderTop: `1px solid ${theme.palette.text.hint}`,
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      gridTemplateColumns: "55% 25% 20%"
    }
  },
  tableHeadCell: {
    display: "flex",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "0 20px",
    "& .MuiTableSortLabel-root": {
      color: theme.palette.text.secondary
    },
    "& .MuiTableSortLabel-root.MuiTableSortLabel-active": {
      color: theme.palette.text.primary
    },
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0 16px"
    }
  },
  tableBody: {
    display: "grid",
    height: "calc(100vh - 180px)"
  },
  rowLink: {
    cursor: "pointer",
    textDecoration: "none"
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "40% 30% 15% 15%",
    height: "40px",
    cursor: "pointer",
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      gridTemplateColumns: "55% 25% 20%",
      width: "100%"
    }
  },
  tableCell: {
    display: "flex",
    alignItems: "center",
    color: "#333333",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "0 20px",
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      padding: "0 16px"
    }
  },
  ellipsis: {
    display: "inline",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  cellRight: {
    justifyContent: "flex-end",
    textAlign: "right"
  },
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 18,
    minHeight: 18,
    width: 18,
    height: 18,
    color: "#51c69e",
    backgroundColor: "rgba(97, 198, 158, 0.15)",
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "50%",
    marginRight: 8
  },
  horsesOnListsBadge: {
    display: "flex",
    border: `1px solid ${theme.palette.warning.main}`,
    backgroundColor: "rgba(216, 47, 68, 0.15)",
    color: theme.palette.warning.dark
  },
  badgeIcon: {
    display: "flex",
    width: "12px"
  },
  horseOnListTooltip: {
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.35)",
    margin: "3px 0"
  },
  horseOnListTooltipTitle: {
    lineHeight: "23px",
    color: "rgba(51, 51, 51, 0.85)",
    fontSize: "12px",
    margin: "0 2px"
  },
  hideDownSX720: {
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  ["lastRace-true"]: { color: "#48769b" },
  ["lastRace-false"]: { color: "#998765" }
}));
